import { TFunction } from "i18next";

export function validateEmail(email: string, t: TFunction): string | undefined {
  const text = email.trim();
  if (text.length === 0) {
    return t('error.required');
  }
  const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w\w+)+$/;
  if (reg.test(text) === false) {
    return t('login.error.email');
  }
  return undefined;
}

export function validatePassword(password: string, t: TFunction): string | undefined {
  const text = password.trim();
  if (text.length === 0) {
    return t('error.required');
  }
  return undefined;
}
